module.exports = __webpack_public_path__ + "static/hacibaba-kuruyemis-sm-db9adc41f5f30be9371b0c38a6caf9d9.jpg";